export interface iNavigation {
  name: string
  icon?: string
  path: string
  pathNew?: string
  permission: string
  children?: Array<iNavigation>
  collection?: string
}

export const NavigationMenus: Array<iNavigation> = [
  {
    name: "Artifacts",
    icon: "fa fa-photo-video",
    path: "/artifacts",
    pathNew: "/new/artifact",
    permission: "Dashboard.Artifacts",
    collection: "Artifacts",
    children: [
      {
        path: "/new/artifact",
        permission: "Dashboard.Artifacts.New",
        name: "New",
      },
      {
        path: "/artifacts",
        permission: "Dashboard.Artifacts.View",
        name: "View",
      },
    ],
  },
  {
    name: "Artists",
    icon: "fa fa-palette",
    path: "/artists",
    pathNew: "/new/artist",
    permission: "Dashboard.Artists",
    collection: "Artists",
    children: [
      {
        path: "/new/artist",
        permission: "Dashboard.Artists.New",
        name: "New",
      },
      {
        path: "/artists",
        permission: "Dashboard.Artists.View",
        name: "View",
      },
    ],
  },

  {
    name: "Art Pieces",
    icon: "fa fa-photo-video",
    path: "/art-pieces",
    pathNew: "/new/art-pieces",
    permission: "Dashboard.ArtPieces",
    collection: "ArtPieces",
    children: [
      {
        path: "/new/art-pieces",
        permission: "Dashboard.ArtPieces.New",
        name: "New",
      },
      {
        path: "/art-pieces",
        permission: "Dashboard.ArtPieces.View",
        name: "View",
      },
    ],
  },
  {
    name: "Ar Targets",
    icon: "fa fa-vr-cardboard",
    path: "/ar-targets",
    pathNew: "/new/ar-target",
    permission: "Dashboard.ARTargets",
    collection: "ARTargets",
    children: [
      {
        path: "/new/ar-target",
        permission: "Dashboard.ARTargets.New",
        name: "New",
      },
      {
        path: "/ar-targets",
        permission: "Dashboard.ARTargets.View",
        name: "View",
      },
    ],
  },
  {
    name: "Assets",
    icon: "fa fa-cubes",
    path: "/assets",
    pathNew: "/new/assets",
    permission: "Dashboard.Assets",
    collection: "Assets",
    children: [
      {
        path: "/new/asset",
        permission: "Dashboard.Assets.New",
        name: "New",
      },
      {
        path: "/assets",
        permission: "Dashboard.Assets.View",
        name: "View",
      },
    ],
  },
  {
    name: "Exhibitions",
    icon: "fa fa-images",
    path: "/exhibitions",
    pathNew: "/new/exhibition",
    permission: "Dashboard.Exhibitions",
    collection: "Exhibitions",
    children: [
      {
        path: "/new/exhibition",
        permission: "Dashboard.Exhibitions.New",
        name: "New",
      },
      {
        path: "/exhibitions",
        permission: "Dashboard.Exhibitions.View",
        name: "View",
      },
    ],
  },
  {
    name: "Spaces",
    icon: "fa fa-archway",
    path: "/spaces",
    pathNew: "/new/space",
    permission: "Dashboard.Spaces",
    collection: "Spaces",
    children: [
      {
        path: "/new/space",
        permission: "Dashboard.Spaces.New",
        name: "New",
      },
      {
        path: "/spaces",
        permission: "Dashboard.Spaces.View",
        name: "View",
      },
    ],
  },
  {
    name: "Users",
    icon: "fa fa-users",
    path: "/users",
    pathNew: "/new/users",
    permission: "Dashboard.Users",
    collection: "Users",
    children: [
      {
        path: "/new/users",
        permission: "Dashboard.Users.New",
        name: "New",
      },
      {
        path: "/users",
        permission: "Dashboard.Users.View",
        name: "View",
      },
    ],
  },
  {
    name: "News",
    icon: "fa fa-newspaper",
    path: "/news",
    pathNew: "/new/news",
    permission: "Dashboard.News",
    collection: "News",
    children: [
      {
        path: "/new/news",
        permission: "Dashboard.News.New",
        name: "New",
      },
      {
        path: "/news",
        permission: "Dashboard.News.View",
        name: "View",
      },
    ],
  },
  {
    name: "Roles",
    icon: "fa fa-user-shield",
    path: "/roles",
    pathNew: "/new/roles",
    permission: "Dashboard.Roles",
    collection: "Roles",
    children: [
      {
        path: "/new/roles",
        permission: "Dashboard.Roles.New",
        name: "New",
      },
      {
        path: "/roles",
        permission: "Dashboard.Roles.View",
        name: "View",
      },
    ],
  },

  {
    name: "Tags",
    icon: "fa fa-tag",
    path: "/tags",
    pathNew: "/new/tags",
    permission: "Dashboard.Tags",
    collection: "Tags",
    children: [
      {
        path: "/new/tags",
        permission: "Dashboard.Tags.New",
        name: "New",
      },
      {
        path: "/tags",
        permission: "Dashboard.Tags.View",
        name: "View",
      },
    ],
  },
  {
    name: "Analytics",
    icon: "fa fa-chart-line",
    path: "/analytics",
    permission: "Dashboard.Analytics",
    collection: "Analytics",
    children: [
      {
        path: "/analytics",
        permission: "Dashboard.Tags.View",
        name: "View",
      },
    ],
  },
  {
    name: "Registrations",
    icon: "fa fa-chart-line",
    path: "/registrations",
    permission: "Dashboard.Registrations",
    collection: "Registrations",
    children: [
      {
        path: "/registrations",
        permission: "Dashboard.Registrations.View",
        name: "View",
      },
    ],
  },
  {
    name: "Featured",
    icon: "fa fa-chart-line",
    path: "/featured",
    permission: "Dashboard.Featured",
    collection: "Featured",
    children: [
      {
        path: "/featured",
        permission: "Dashboard.Featured.View",
        name: "View",
      },
    ],
  },
  {
    name: "SEO",
    icon: "fa fa-chart-line",
    path: "/seo",
    permission: "Dashboard.SEO",
    collection: "SEO",
    children: [
      {
        path: "/seo",
        permission: "Dashboard.SEO.View",
        name: "View",
      },
    ],
  },
  {
    name: "Packages",
    icon: "fa fa-cubes",
    path: "/packages",
    permission: "Dashboard.Packages",
    collection: "Packages",
    children: [
      {
        path: "/new/package",
        permission: "Dashboard.Packages.New",
        name: "New",
      },
      {
        path: "/packages",
        permission: "Dashboard.Packages.View",
        name: "View",
      },
    ],
  },
]
